import { render, staticRenderFns } from "./TpHeader.vue?vue&type=template&id=5677290a&scoped=true&"
import script from "./tpheader.js?vue&type=script&lang=js&"
export * from "./tpheader.js?vue&type=script&lang=js&"
import style0 from "./TpHeader.vue?vue&type=style&index=0&id=5677290a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677290a",
  null
  
)

export default component.exports